export default __webpack_public_path__ + "static/realWorldImg2-bd020a14fe22428c45084dc2b5fe2898.png";